import React, { useEffect, useMemo } from "react";

import { useAuth } from "./../../hooks/auth";

import Header from "./../../components/Header/";
import Footer from "./../../components/Footer/";

import { Link, useHistory, useLocation } from "react-router-dom";

import { Container, Content, FinancialReportContainer } from "./styles";
import FormToLoginPage from "../../components/FormToLoginPage";

import { hasScheduleRequest, getScheduleRequest } from "../../utils/scheduleUtils";
import { getPostLoginRedirectPath } from "../../utils/authRedirect";
import GoogleAuthButton from "../../components/GoogleAuthButton";
import WhatsAppLoginFlow from "../../components/WhatsAppLoginFlow";
import { Divider, SocialButtonsContainer } from "./styles";
import { getPostLoginHomePath } from "../../utils/canManageSubLogins";

interface IState {
  fromSite?: boolean;
  previousScreen?: "property";
  propertyId?: string;
  consultant_id?: string;

  from?: string;
}

export default function Login() {
	const { user } = useAuth();
	const history = useHistory();
	const location = useLocation<IState>();
	const { state } = location;

	const deactivatedAccountMessage = useMemo(() => {
		const params = new URLSearchParams(location.search);
		return params.get("reason") === "deactivated"
			? "Este acesso foi desativado. Entre em contato com o proprietário responsável."
			: null;
	}, [location.search]);

	useEffect(() => {
		if (!user) return;

		const fromPath = getPostLoginRedirectPath(
			location.search,
			state?.from
		);

		if (fromPath) {
			history.replace(fromPath);
			return;
		}

		if (state) {
			history.goBack();
			return;
		}

		history.push(getPostLoginHomePath(user));
		// eslint-disable-next-line
	}, [history, user, state, location.search]);

	const handleSocialSuccess = () => {
		if (hasScheduleRequest()) {
			const scheduleRequest = getScheduleRequest();
			history.push(`/schedule/${scheduleRequest.propertyId}`, scheduleRequest.state);
			return;
		}

		const fromPath = getPostLoginRedirectPath(
			location.search,
			state?.from
		);

		if (fromPath) {
			history.replace(fromPath);
			return;
		}

		const storedUserRaw = localStorage.getItem("@7Cantos:user");
		const storedUser = storedUserRaw ? JSON.parse(storedUserRaw) : user;
		history.push(getPostLoginHomePath(storedUser));
	};


	return (
		<Container>
			<Header />
			<Content>
				<h2>FAZER LOGIN</h2>

				<h1>Seu lar dos sonhos está ao alcance de um clique.</h1>

				{deactivatedAccountMessage && (
					<p
						style={{
							background: "#FEF2F2",
							border: "1px solid #FECACA",
							borderRadius: 12,
							color: "#B91C1C",
							fontSize: 14,
							marginBottom: 16,
							padding: "12px 16px",
						}}
					>
						{deactivatedAccountMessage}
					</p>
				)}

				<FormToLoginPage />

				<Divider>OU</Divider>

				<SocialButtonsContainer>
					<GoogleAuthButton />
					<WhatsAppLoginFlow onSuccess={handleSocialSuccess} />
				</SocialButtonsContainer>

				<p>
					Ainda não tem cadastro?{" "}
					<Link
						to={{
							pathname: "/register",
							state:
								!!state && state.previousScreen === "property"
									? {
										prevPath: history.location.pathname,
										previousScreen: "property",
										propertyId: state.propertyId,
										consultant_id: state.consultant_id,
									}
									: { prevPath: history.location.pathname },
						}}
					>
						Crie sua conta!
					</Link>
				</p>

				<Link to="/forgot-password">Esqueci minha senha</Link>

				<FinancialReportContainer>
					<p>
						Já é Proprietário ou Inquilino de um imóvel gerido pela 7Cantos? Aqui
						você tem acesso a faturas para pagamento do aluguel, extrato detalhado
						de repasses e documentos pertinentes a locação do seu imóvel
					</p>

					<a href="https://pauloregisarcan.superlogica.net/clients/areadofornecedor">
						Já sou Proprietário
					</a>
					<a href="https://pauloregisarcan.superlogica.net/clients/areadocliente">
						Já sou Inquilino
					</a>
				</FinancialReportContainer>
			</Content>
			<Footer />
		</Container>
	);
}
